const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete,
};

const baseUrl = process.env.REACT_APP_SOLVER_BASE_URL;
const baseUrlLaravel = process.env.REACT_APP_LARAVEL_BASE_URL;

function getFullUrl(url) {
  return `${baseUrl}${url}`;
}

function getFullUrlLaravel(url) {
  return `${baseUrlLaravel}/api${url}`;
}

function getAuthHeader() {
  const token = localStorage.getItem("access_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function get(url, isLaravel = false) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...getAuthHeader(),
      Accept: "application/json",
    },
  };
  return fetch(
    isLaravel ? getFullUrlLaravel(url) : getFullUrl(url),
    requestOptions,
  ).then(handleResponse);
}

function post(url, body, isLaravel) {
  const headers = {
    ...getAuthHeader(),
    Accept: "application/json",
  };
  let b = JSON.stringify(body);
  if (body instanceof FormData) {
    b = body;
  } else {
    headers["Content-Type"] = "application/json";
  }
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: b,
  };
  return fetch(
    isLaravel ? getFullUrlLaravel(url) : getFullUrl(url),
    requestOptions,
  ).then(handleResponse);
}

function put(url, body, isLaravel) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...getAuthHeader(),
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(body),
  };
  return fetch(
    isLaravel ? getFullUrlLaravel(url) : getFullUrl(url),
    requestOptions,
  ).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url, isLaravel) {
  const requestOptions = {
    method: "DELETE",
    headers: {
      ...getAuthHeader(),
      Accept: "application/json",
    },
  };
  return fetch(
    isLaravel ? getFullUrlLaravel(url) : getFullUrl(url),
    requestOptions,
  ).then(handleResponse);
}

// helper functions

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.statusCode === 422) {
        return Promise.reject(data);
      }
      const error = (data && data) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

export default fetchWrapper;
